import { stripHTML } from './stripHTML';

export function generateFaqRichData(
  items: Array<{ title: string; content: string }> | null | undefined,
) {
  const mainEntity =
    items?.map((item) => ({
      '@type': 'Question',
      name: stripHTML(item.title),
      acceptedAnswer: {
        '@type': 'Answer',
        text: stripHTML(item.content),
      },
    })) || null;

  return mainEntity
    ? {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        name: 'FAQs',
        mainEntity,
      }
    : {};
}
